// ** React Imports
import { Outlet, useLocation } from "react-router-dom";

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout";
import PortalLayouts from "@layouts/PortalLayouts";

// ** Menu Items Array
import navigation from "@src/navigation/vertical";
import sellerNavigation from "@src/navigation/vertical/sellerMenuItems";
import fbmNavigation from "@src/navigation/vertical/fbmMenuItems";
import wholesalerNavigation from "@src/navigation/vertical/wholesalerMenuItems";
import adminNavigation from "@src/navigation/vertical/adminMenuItems";
import { useSelector } from "react-redux";
import affiliateMenuItems from "../navigation/vertical/affiliateMenuItems";

const VerticalLayout = (props) => {
  // const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  const location = useLocation();
  const selectedPath = location.pathname.includes('/fbm/');

  let role = localStorage.getItem('selectedRole');
  let sideMenuItems = [];
  const { isApproved } = useSelector((state) => state.fbmApproval);

  if (role === 'customer') {
    sideMenuItems = navigation;
  } else if (role === 'seller') {
    sideMenuItems = isApproved || selectedPath ? fbmNavigation : sellerNavigation;
  } else if (role === 'wholesaler') {
    sideMenuItems = isApproved || selectedPath ? fbmNavigation : wholesalerNavigation;
  } else if (role === 'admin') {
    sideMenuItems = adminNavigation;
  } else if (role === 'affiliate') {
    sideMenuItems = affiliateMenuItems;
  }

  return (

    // for portals
    <Layout menuData={sideMenuItems} {...props}>
      <Outlet />
    </Layout>


    // for landing page
    // <PortalLayouts  {...props}>
    //     <Outlet />
    // </PortalLayouts>

  )
}

export default VerticalLayout;
